@use '@fukuri-admins/ui/layout' as *;

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.dropZone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: spacing('8');

  width: 100%;
  min-height: 126px;
  box-sizing: border-box;
  padding: spacing('20') spacing('24');

  background-color: background('Secondary');
  border: 1px dashed border('Quaternary');
  border-radius: borderRadius('lg');

  cursor: pointer;
  transition: background-color 0.2s ease;

  // ホバー・ドラッグ中は黒5%オーバーレイで暗くする
  &:hover:not(.disabled):not(.uploading),
  &.dragging {
    background-image: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05));
  }

  // フォーカス状態
  &:focus-visible {
    outline: none;
    border: 2px solid border('Focus');
    background-color: background('Sky');
  }

  // エラー状態
  &.error {
    background-color: background('Red');
    border: 1px solid border('Red_Darken');
    border-style: solid;
  }

  // uploading 状態
  &.uploading {
    cursor: default;
  }

  // disabled 状態
  &.disabled {
    background-color: transparent;
    cursor: default;
  }
}

// テキスト間 gap: 4px
.textGroup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: spacing('4');
}

.label {
  @include typography('Jp/14_W3');
  color: text('High');
  margin: 0;

  .disabled & {
    color: text('Disabled');
  }
}

.or {
  @include typography('Jp/12_W3');
  color: text('Low');
  margin: 0;

  .disabled & {
    color: text('Disabled');
  }
}

// ファイル選択ダイアログ用の非表示input
.hiddenInput {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

// Loading 状態
.loadingContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: spacing('8');
}

.loadingText {
  @include typography('Jp/12_W3');
  color: text('High');
  margin: 0;
}

// スピナー（size=md: 24px）
.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid border('Quaternary');
  border-top-color: border('Focus');
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  flex-shrink: 0;
}
